import { render, staticRenderFns } from "./adminMenu.vue?vue&type=template&id=5f439654&scoped=true"
import script from "./adminMenu.vue?vue&type=script&lang=js"
export * from "./adminMenu.vue?vue&type=script&lang=js"
import style0 from "./adminMenu.vue?vue&type=style&index=0&id=5f439654&prod&lang=scss&scoped=true"
import style1 from "./adminMenu.vue?vue&type=style&index=1&id=5f439654&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f439654",
  null
  
)

export default component.exports